<script setup>
import { useForm } from '@inertiajs/vue3';
import { inject } from 'vue';

// Components
import Card from '@/Components/Blocks/Team/Card.vue';
import Button from '@/Components/Button/Button.vue';
import Pagination from '@/Components/Pagination.vue';

const props = defineProps({
    query: Object,
    title: String,
    team: Object,
    amount_team_members: String,
    button_label: String,
    external_url: String,
    intended_url: String,
    page_id: String,
});

const route = inject('route');

const form = useForm({
    page: props.projects?.page ?? 1,
    categories: props.query?.categories ?? [],
});

const submit = (resetPage = true) => {
    form.page = resetPage ? 1 : form.page;
    form.get(route('public.projects.index'), {
        preserveState: true,
    });
};

const setPage = (e) => {
    form.page = e;
    submit(false);
};
</script>

<template>
    <div
        v-if="team.data"
        class="bg-gray-lighter"
    >
        <div class="container py-12 md:py-16">
            <h2
                v-if="title"
                class=""
                v-html="title"
            />

            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                <article
                    v-for="member in team.data"
                    :key="member.id"
                    class="' flex flex-col rounded-xl bg-white"
                >
                    <Card :member="member" />
                </article>
            </div>

            <div class="flex justify-center">
                <Button
                    :is="'a'"
                    v-if="button_label && intended_url"
                    :href="intended_url"
                    :label="button_label"
                    :target="page_id === null || page_id === undefined ? true : false"
                    class="relative z-30 mt-8 w-auto"
                />
            </div>

            <Pagination
                v-if="team !== 'undefined' && team.links.length >= 16"
                :links="team.links"
                :page-data="team"
                @setPage="setPage"
            />
        </div>
    </div>
</template>
